import { stringify } from '@refinedev/simple-rest';
import { message } from 'antd';
import { AxiosInstance } from 'axios';

import { FirebaseTokenData } from '@/model/General/FirebaseTokenData';
import { UserNotification } from '@/model/General/Notification';

import UserApi from './UserApi';

class UserRepository {
  userApi: UserApi;

  constructor(axiosInstance: AxiosInstance) {
    this.userApi = new UserApi(axiosInstance);
  }

  registerFirebaseToken(data: FirebaseTokenData) {
    this.userApi
      .registerFirebaseToken(data)
      .then(() => {
        // Si el usuario de la PWA tiene la sesión iniciada, se guarda el token de firebase en la DB
        localStorage.removeItem('firebaseToken');
      })
      .catch(() => {
        // Si la sesión no está iniciada aun, se guarda el token de firebase en local storage, esperando hasta que el
        // usuario inicie sesión
        if (data) this.saveTokenDataInLocalStorage(data);
      });
  }

  getUserNotification(): Promise<UserNotification[]> {
    return this.userApi
      .getUserNotification()
      .then(notifications => {
        return notifications;
      })
      .catch(() => {
        message.error('Error al obtener las notificaciones del usuario');

        return [];
      });
  }

  markNotificationRead(notificationId): Promise<UserNotification | null> {
    return this.userApi
      .markNotificationRead(notificationId)
      .then(notification => {
        return notification;
      })
      .catch(() => {
        message.error('Error al obtener las notificaciones del usuario');

        return null;
      });
  }

  saveTokenDataInLocalStorage(data: FirebaseTokenData) {
    localStorage.setItem('firebaseToken', stringify(data));
  }
}

export default UserRepository;
